import { RouteAnnouncer } from '@/components/RouteAnnouncer';
import { RoutePreloader } from '@/components/RoutePreloader';
import { ProtectedAccess } from '@/components/ProtectedAccess';
import { useAuthStore } from '@/state/auth';
import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

// Import lazy-loaded components
import {
    AuthLayout,
    ComponentsDemo,
    CreateProfilePage,
    DashboardLayout,
    DashboardPage,
    GuestLandingPage,
    LoginPage,
    ResetPasswordPage,
    SettingsPage,
    SignupPage,
    SupportPage,
    VerifyPage,
} from '@/routes/lazyRoutes';

function App() {
  const { user, isLoading, checkAuth, isAuthenticated } = useAuthStore();

  useEffect(() => {
    // Check if user is authenticated on app start
    checkAuth();
  }, [checkAuth]);

  return (
    <>
      <RouteAnnouncer />
      {/* Route preloader for intelligent code splitting */}
      <RoutePreloader isAuthenticated={!!user} />

      <Routes>
        {/* Public routes */}
        <Route path="/" element={<GuestLandingPage />} />

        <Route path="/auth/*" element={<AuthLayout />}>
          <Route path="login" element={<LoginPage />} />
          <Route path="signup" element={<SignupPage />} />
          <Route path="verify" element={<VerifyPage />} />
          <Route path="create-profile" element={<CreateProfilePage />} />
          <Route path="reset-password" element={<ResetPasswordPage />} />
        </Route>

        {/* Demo route (accessible without authentication for development) */}
        <Route path="/demo" element={<ComponentsDemo />} />

        {/* Protected routes - guarded by ProtectedAccess */}
        <Route element={<DashboardLayout />}>
          <Route
            path="/dashboard"
            element={
              <ProtectedAccess>
                <DashboardPage />
              </ProtectedAccess>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedAccess>
                <SettingsPage />
              </ProtectedAccess>
            }
          />
          <Route
            path="/support"
            element={
              <ProtectedAccess>
                <SupportPage />
              </ProtectedAccess>
            }
          />
        </Route>

        {/* Catch-all: send any unknown route to landing/login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default App;
